module.exports = __webpack_public_path__ + "media/flags/gl-b9bb3aa6.svg";